// add lazy-load supported
import LazyLoad from "vanilla-lazyload";

let myLazyLoad = new LazyLoad();


(
	function () {
		'use strict';
		//--------------------------------------------------------------------------------------------------------------
		//	JACPOT TIMER
		//--------------------------------------------------------------------------------------------------------------
		let win = document.getElementById( 'wt' ); //ID элемента, в котором будет выведено число
		if ( win ) {
			winTimer( win );
		}

		function winTimer( el ) {
			let default_val = 1225255, //стартовое значение, которое увидит пользователь при первой загрузке страницы
				minimum_val = 1000000, //к этому значению будет сброшено число, когда перевалит максимальное значение
				maximum_val = 1825255, //максимальное значение числа
				current = 0, //тут будет хранится текущее значение числа
				min = 0, //минимальное приращение
				max = 1, //максимальное приращение
				min_time = 3000, //мин.временной интервал обновления
				max_time = 20000, //макс.временной интервал обновления
				timer = '', //здесь будет хранится рекурсивный вызов таймера
				time = '', //а здесь - случайный временной интервал
				method = {}; //методы (функции)

			method.init = function () {
				//получим значение числа из localStorage
				current = parseFloat( localStorage.getItem( 'winValue' ) ); //сразу преобразуем в число
				if ( !current ) {//если его там нет - установим дефолтное
					method.save( default_val );
				}

				method.show( current ); //отобразим на странице

				//рекурсивный setTimeot, в который передадим случайный временной интервал time
				time = method.getRandomTime();
				timer = setTimeout( function tick() {
					method.add();//увеличили значение числа на случайную величину и отобразили на странице
					time = method.getRandomTime();
					timer = setTimeout( tick, time );
				}, time );
			};

			method.save = function ( val ) {//запишем текущее значение в localStorage
				try {
					saveToStorage();
				} catch ( e ) {
					if ( e == QUOTA_EXCEEDED_ERR ) {//если оно переполнено - очистим и запишем повторно
						localStorage.clear();
						saveToStorage();
					}
				}

				function saveToStorage() {
					localStorage.setItem( 'winValue', val );
					current = val;
				}
			};

			method.show = function ( val ) { //отобразим текущее значение на странице, предварительно преобразовав число в нужный формат
				el.innerHTML = method.numberFormat( val, 2, '.', ',' );
			};

			method.add = function () {//увеличим значение числа на случайную величину
				// будем брать значение из localStorage а не из переменной, т.к. страница может быть открыта в двух вкладках (например) и это позволит частично их синхронизировать
				current = parseFloat( localStorage.getItem( 'winValue' ) ) + Math.round( (
					                                                                         Math.random() * (
						                                                                         max - min
					                                                                         ) + min
				                                                                         ) * 100 ) / 100; //увеличим на случайное число, округленное до 2 знаков после запятой
				if ( current > maximum_val ) {//если перевалили за максимум - сбросим к минимуму
					current = minimum_val;
				}
				method.save( current ); //сохранили в localStorage
				method.show( current ); //вывели на экран
			};


			method.getRandomTime = function () {//вернем случайный целый интервал от 200 до 8000 милисекунд
				return Math.floor( Math.random() * (
					max_time - min_time + 1
				) ) + min_time;
			};

			// преобразуем число в нужный формат
			// number - число
			// decimal - число знаков после разделителя
			// dec_point - символ разделителя
			// thousand_sep - разделитель тысячных
			method.numberFormat = function ( number, decimals, dec_point, thousands_sep ) {
				number = (
					number + ''
				).replace( /[^0-9+\-Ee.]/g, '' );
				let n = !isFinite( + number ) ? 0 : + number,
					prec = !isFinite( + decimals ) ? 0 : Math.abs( decimals ),
					sep = (
						typeof thousands_sep === 'undefined'
					) ? ',' : thousands_sep,
					dec = (
						typeof dec_point === 'undefined'
					) ? '.' : dec_point,
					s = '',
					toFixedFix = function ( n, prec ) {
						let k = Math.pow( 10, prec );
						return '' + (
							Math.round( n * k ) / k
						)
							.toFixed( prec );
					};
				// Fix for IE parseFloat(0.55).toFixed(0) = 0;
				s = (
					prec ? toFixedFix( n, prec ) : '' + Math.round( n )
				)
					.split( '.' );
				if ( s[0].length > 3 ) {
					s[0] = s[0].replace( /\B(?=(?:\d{3})+(?!\d))/g, sep );
				}
				if ( (
					     s[1] || ''
				     )
					     .length < prec ) {
					s[1] = s[1] || '';
					s[1] += new Array( prec - s[1].length + 1 )
						.join( '0' );
				}
				return s.join( dec );
			};

			method.init();
		}

		//--------------------------------------------------------------------------------------------------------------
		//	FRONT PAGE SLIDER
		//--------------------------------------------------------------------------------------------------------------
		let slider = document.getElementById( 'slider' ); //id списка слайдера
		if ( slider ) {
			initSlider();
		} //можно передать значение интервала в качестве параметра, например, initSlider(2000) - для запуска слайдера с интервалом в 2с.


		function initSlider( time ) {
			let slides = slider.getElementsByTagName( 'li' ), //элементы слайдера
				buttons, //запишем сюда массив кнопок пейджера
				method = {}, //методы
				handle = {}; //переменные

			handle.count = slides.length; //кол-во слайдов
			handle.current = 0; //текущий слайд
			handle.delay = 5000; //интервал смены слайдов по-умолчанию

			method.addPager = function () {//добавим в разметку пейджер и создадим управление прокруткой
				let pager = document.createElement( 'div' );
				pager.className = 'pl-slt-pager';
				for ( let i = 0; i < handle.count; i ++ ) {
					let item = document.createElement( 'span' );
					item.className = 'pl-slt-pager__item';
					item.setAttribute( 'data-item', i );
					pager.appendChild( item );
					method.clickOnPager( item );//добавим обработку клика по кнопке (вынесем за пределы цикла)
				}
				slider.appendChild( pager );//добавили кнопки пейджера в слайдер
				buttons = slider.getElementsByClassName( 'pl-slt-pager__item' ); //после того как пейджер создан, запишем его элементы в массив
			};

			method.clickOnPager = function ( el ) {//обработка клика по кнопке пейджера
				el.addEventListener( 'click', function () {
					let data = el.getAttribute( 'data-item' );
					if ( data === handle.current ) {
						return false;
					} else {
						method.goToSlide( data ); //переходим на нужный слайд
					}
				} );
			};

			method.startSlider = function () {//запуск (перпезапуск)
				addClass( slides[handle.current], 'current' );
				addClass( buttons[handle.current], 'current' );
				method.requestInterval();//включаем автоматическую смену слайдов
			};

			method.hideSlide = function () {
				removeClass( slides[handle.current], 'current' );
				removeClass( buttons[handle.current], 'current' );
			};

			method.showSlide = function () {
				addClass( slides[handle.current], 'current' );
				addClass( buttons[handle.current], 'current' );
			};

			method.nextSlide = function () {
				method.hideSlide();
				handle.current = (
					                 handle.current + 1
				                 ) % handle.count;
				method.showSlide();
			};

			method.goToSlide = function ( n ) {
				method.pauseSlider();
				method.hideSlide();
				handle.current = n;
				method.startSlider();
			};

			method.requestInterval = function () {//для более точного выполнения, будем вызывать рекурсивно setTimeout вместо setInterval
				handle.timer = setTimeout( function loop() {
					method.nextSlide();
					handle.timer = setTimeout( loop, handle.delay );
				}, handle.delay );
			};

			method.pauseSlider = function () {//остановим автоматическую прокрутку
				clearTimeout( handle.timer );
			};

			method.init = (
				function () {
					if ( !isNaN( time ) ) { //проверим переданное значение интервала смены слайдов (если есть, если нет - оставим дефолтное)
						handle.delay = Math.round( time );
						if ( handle.delay < 1000 ) {
							handle.delay = 1000;
						}
					}

					//если на странице более чем 1 слайд - запустим
					if ( slides.length > 1 ) {
						method.addPager();
						method.startSlider();
					} else { //иначе просто покажем первый слайд
						addClass( slides[0], 'current' );
					}
				}
			)();
		}

		//--------------------------------------------------------------------------------------------------------------
		//	SIDEBAR CAROUSEL
		//--------------------------------------------------------------------------------------------------------------
		let Carousel = (
			function () {
				let method = function ( list ) {
					this.slider = list;//список слайдов
					this.slides = this.slider.getElementsByTagName( 'li' );//слайды
					this.count = this.slides.length;//кол-во слайдов
					this.size = this.slider.getAttribute( 'data-size' );//высота (или ширина) слайда
					this.delay = this.slider.getAttribute( 'data-time' );//время смены слайдов
					this.mode = this.slider.getAttribute( 'data-mode' ); //режим (вертикальный - vertical, горизонтальный - horizontal )
					this.current = 0; //текущий слайд
					this.handle = {}; //будем хранить состояние слайдера (запущен - остановлен)
				};

				method.prototype.init = function () {
					this.handle.isStarted = false; //флаг состояния
					//проверим переданные параметры
					if ( isNaN( this.size ) ) {//если не указали высоту (или ширину) слайда
						this.size = 100;
					}

					if ( isNaN( this.delay ) || this.delay < 1000 ) {//если забыли указать время смены слайдов
						this.delay = 2000;
					}

					if ( !(
						this.mode === 'vertical' || this.mode === 'horizontal'
					) ) {//если забыли указать режим
						this.mode = 'vertical';
					}

					//поставим последний элемент перед первым
					let last = this.slides[this.count - 1];
					this.slider.insertBefore( last, this.slides[0] );

					if ( this.mode === 'horizontal' ) { //если слайдер - горизонтальный
						//сместим список влево на ширину элемента
						this.slider.style.left = - this.size + 'px';
						//зададим ширину списка по кол-ву элементов
						this.slider.style.width = this.size * this.count + 'px';
					} else { //если слайдер - вертикальный
						//сместим список на высоту элемента
						this.slider.style.top = - this.size + 'px';
					}

					this.start(); //запускаем
					this.hover(); //подключаем события hover
				};

				method.prototype.start = function () {//старт автоматической прокрутки слайдов
					if ( !this.handle.isStarted ) {
						this.handle.isStarted = true;
						this.handle.timer = setInterval( this.move.bind( this ), this.delay );//запускаем с интервалом delay
					}
				};

				method.prototype.stop = function () {//остановим автоматическую прокрутку слайдов
					if ( this.handle.isStarted ) {
						this.handle.isStarted = false;
						clearTimeout( this.handle.timer );
					}
				};

				method.prototype.hover = function () {//будем останавливать авт.прокрутку при наведении мыши
					this.slider.addEventListener( 'mouseover', function () {
						this.stop();
					}.bind( this ) );
					this.slider.addEventListener( 'mouseout', function () {
						this.start();
					}.bind( this ) );
				};

				method.prototype.move = function () {
					//анимируем и смещаем список на один элемент
					addClass( this.slider, 'moved' );
					if ( this.mode === 'horizontal' ) {
						this.slider.style.transform = 'translateX( -' + this.size + 'px)';
					} else {
						this.slider.style.transform = 'translateY( -' + this.size + 'px)';
					}
					//через 1с (1с - время анимации при смене слайда) поставим первый элемент в конец списка
					setTimeout( this.change.bind( this ), 1000 );
				};

				method.prototype.change = function () {
					removeClass( this.slider, 'moved' ); //отключаем эффект анимации для transform
					this.slider.style.transform = 'none';
					this.slider.appendChild( this.slides[0] );//перестановка
				};

				return method;
			}
		)();

		//start carousels:
		let slider1 = document.getElementById( 'crsl01' ),
			slider2 = document.getElementById( 'crsl02' );

		if ( slider1 ) {
			let side_slider1 = new Carousel( slider1 );
			side_slider1.init();
		}

		if ( slider2 ) {
			let side_slider2 = new Carousel( slider2 );
			side_slider2.init();
		}


		//--------------------------------------------------------------------------------------------------------------
		//	HELPERS
		//--------------------------------------------------------------------------------------------------------------
		function addClass( el, className ) {
			if ( el.classList ) {
				el.classList.add( className );
			} else {
				el.className += ' ' + className;
			}
		}

		function removeClass( el, className ) {
			if ( el.classList ) {
				el.classList.remove( className );
			} else {
				el.className = el.className.replace(
					new RegExp( '(^|\\b)' + className.split( ' ' ).join( '|' ) + '(\\b|$)', 'gi' ), ' ' );
			}
		}
	}
)();


// load more
(
	function () {
		let btn = document.getElementById( 'true_loadmore' );

		if ( btn ) {
			loadMore();
		}

		function loadMore() {
			let btn_text = btn.textContent;

			btn.addEventListener( 'click', function () {
				btn.disabled = true;
				btn.textContent = 'Load...';
				let request = new XMLHttpRequest();
				request.open( 'POST', ajaxurl + '?action=loadmore&query=' + true_posts + '&page=' + current_page,
					true );
				request.send();
				request.onload = function () {
					if ( request.status >= 200 && request.status < 400 ) {
						let resp = request.responseText;
						if ( resp && resp !== '0' ) {
							let div = document.createElement( "div" );
							div.innerHTML = resp;
							while ( div.firstChild ) {
								let item = div.removeChild( div.firstChild );
								btn.parentNode.parentNode.insertBefore( item, btn.parentNode );
							}
							if ( current_page == (
								max_pages
							) ) {
								btn.parentNode.style.display = 'none';
							}// если последняя страница, скрываем кнопку
							current_page ++; // увеличиваем номер страницы на единицу
							btn.textContent = btn_text;
							btn.disabled = false;
						} else {
							btn.parentNode.style.display = 'none';
							console.log( 'No response...' );
						}

					} else {
						// We reached our target server, but it returned an error
						console.log( 'Error...' );
					}
				};
				request.onerror = function () {
					// There was a connection error of some sort
					console.log( 'Connection Error...' );
				};
			} );
		}
	}
)();

window.onscroll = function () {
	document.querySelector( '.to_top' ).onclick = ( ev ) => {
		ev.preventDefault();
		document.documentElement.scrollTop = 0;
	};
};